import React from 'react'
import CategorySlider from './CategorySlider'
import CategoryShortcut from './CategoryShortcut'
import FeaturedProducts from './FeaturedProducts'
import SEO from './SEO'
import Project from '../pages/Services/Project'
import WhyChooseUs from './WhyChooseUs'

function Home() {
  const structuredData = [
    {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "Techie Interiors",
      "image": "https://techieinteriors.co.ke/techLogo.jpeg",
      "@id": "https://techieinteriors.co.ke/#localbusiness",
      "url": "https://techieinteriors.co.ke/",
      "telephone": "+254748600208",
      "email": "info@techieinteriors.co.ke",
      "priceRange": "KSh",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Nairobi",
        "addressLocality": "Nairobi",
        "addressRegion": "Nairobi County",
        "postalCode": "00100",
        "addressCountry": "KE"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": -1.286389,
        "longitude": 36.817223
      },
      "areaServed": [
        {
          "@type": "City",
          "name": "Nairobi"
        },
        {
          "@type": "Country",
          "name": "Kenya"
        }
      ],
      "openingHoursSpecification": {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday"
        ],
        "opens": "08:00",
        "closes": "18:00"
      },
      "description": "Techie Interiors provides premium interior design solutions in Nairobi, specializing in gypsum ceilings, custom wardrobes, kitchen cabinets, and modern fit-outs for residential and commercial spaces.",
      "sameAs": [
        "https://www.facebook.com/techieinteriors",
        "https://www.instagram.com/techie_interiors/",
        "https://www.linkedin.com/company/techieinteriors/",
        "https://www.twitter.com/techieinteriors",
        "https://www.tiktok.com/@techieinteriors",
        "https://www.youtube.com/@techieinteriors"
      ]
    },
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "name": "Techie Interiors",
      "url": "https://techieinteriors.co.ke/",
      "potentialAction": {
        "@type": "SearchAction",
        "target": {
          "@type": "EntryPoint",
          "urlTemplate": "https://techieinteriors.co.ke/shop?search={search_term_string}"
        },
        "query-input": "required name=search_term_string"
      }
    }
  ];

  return (
    <div>
      <div style={{ textAlign: 'center', padding: '40px 20px', backgroundColor: '#f9f9f9', borderBottom: '1px solid #eaeaea' }}>
        <h1 style={{ margin: 0, fontSize: '2.5rem', color: '#333', fontWeight: 'bold' }}>
          Premium Interior Design Services and Products in Nairobi, Kenya
        </h1>
        <p style={{ marginTop: '10px', fontSize: '1.2rem', color: '#666', maxWidth: '800px', marginLeft: 'auto', marginRight: 'auto' }}>
          Techie Interiors is your one-stop shop for residential and commercial interior design services and premium interior products in Nairobi and across Kenya. We specialize in gypsum ceilings, TV wall units, kitchen cabinets, wardrobes, renovation fit-outs, and a wide selection of top-quality decor items to complete your space.
        </p>
      </div>
      <SEO
        title="Interior Design Services in Nairobi, Kenya | Techie Interiors"
        description="Techie Interiors is your one-stop shop for residential and commercial interior design services and premium interior products in Nairobi and across Kenya, including gypsum ceilings, TV wall units, kitchen cabinets, wardrobes, and renovation fit-outs."
        image="/techLogo.jpeg"
        url="https://techieinteriors.co.ke/"
        structuredData={structuredData}
      />
      <CategorySlider />
      <CategoryShortcut />
      <FeaturedProducts />
      <Project showSEO={false} />
      <WhyChooseUs />
    </div>
  )
}

export default Home